import './layout-style.scss'
import './layout.css'

import { ThemeProvider as NextThemeProvider } from '@emotion/react'
import { useNavFooter, useUserRegionCH } from '@monacohq/mkt-nav-footer'
import { Link as GatsbyLink, navigate } from 'gatsby'
import React from 'react'
import { ScreenClassProvider } from 'react-grid-system'
import Helmet from 'react-helmet'
import { I18nextProvider } from 'react-i18next'

import { OneLinkProvider } from '@/modules/components/hooks/useOneLink.tsx'

import { CategoriesProvider, PostsProvider } from '../../hooks'
import i18n from '../../i18n/config'
import nextTheme from '../../modules/next-theme'
import { ThemeGlobalStyle, ThemeProvider } from '../../modules/theme.jsx'
import SearchBar from '../search/search'

const AdaptLink = ({ href, style, children, ...restProps }) => (
  <GatsbyLink to={href} activeStyle={style} {...restProps}>
    {children}
  </GatsbyLink>
)

const Layout = ({ children, pageContext }) => {
  const userRegion = useUserRegionCH()
  const onSearch = (keyword) => {
    navigate(`/search/?keyword=${keyword}`, { replace: false })
  }

  if (pageContext) {
    i18n.changeLanguage(pageContext.lang)
  }

  const { Nav, Footer } = useNavFooter({
    lang: pageContext.lang,
    country: userRegion,
    hasLangCountrySwitch: false,
    onSearch: onSearch,
    hasSearchBar: true,
    Link: AdaptLink,
    mktBaseUrl: process.env.GATSBY_MKT_BASE_URL,
  })

  return (
    <>
      <Helmet
        bodyAttributes={{
          class: 'fs-unmask',
        }}
      >
        <script src="https://cdn.optimizely.com/js/22092170568.js"></script>
        <script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          data-domain-script={process.env.GATSBY_COOKIE_LAW}
          async
        ></script>
        <script>{'function OptanonWrapper() {}'}</script>
        <script src="/lib/gt.js"></script>
      </Helmet>
      <I18nextProvider i18n={i18n}>
        <PostsProvider>
          <CategoriesProvider>
            <NextThemeProvider theme={nextTheme}>
              <ThemeProvider>
                <ScreenClassProvider>
                  <OneLinkProvider>
                    <ThemeGlobalStyle />
                    <div className="global-wrapper">
                      <Nav />
                      <main className="container">{children}</main>
                      <div className="container-footer">
                        <Footer />
                      </div>
                      <SearchBar />
                    </div>
                  </OneLinkProvider>
                </ScreenClassProvider>
              </ThemeProvider>
            </NextThemeProvider>
          </CategoriesProvider>
        </PostsProvider>
      </I18nextProvider>
    </>
  )
}

export default Layout
